import React from "react";
import PropTypes from "prop-types";
import Timeago from "react-timeago";
import { dateFormatterWithoutTime } from "../../../utils";
import "./time-stamp.m.css";

export const TimeStamp = ({ story, timestampColor = "#333" }) => {
  const time = story["last-published-at"] || story["first-published-at"];
  return (
    <div styleName="time" style={{ color: timestampColor }}>
      <Timeago date={time} formatter={dateFormatterWithoutTime} />
    </div>
  );
};

TimeStamp.propTypes = {
  story: PropTypes.object,
  isBottom: PropTypes.bool,
  timestampColor: PropTypes.string
};
